import { Box, Link, Typography } from '@mui/material';

import { COLORS } from '../../IndividualPlan/tokens';

type GoalsAccountabilityProps = {
  ctaHref?: string;
};

export function GoalsAccountability({ ctaHref = '#' }: GoalsAccountabilityProps) {
  return (
    <Box component="section" sx={{ mt: 4 }}>
      <Typography
        id="goals-accountability-heading"
        component="h2"
        sx={{ color: COLORS.ink, fontSize: 18, fontWeight: 700, mb: 1 }}
      >
        Goals &amp; Accountability
      </Typography>

      <Typography sx={{ color: COLORS.muted, fontSize: 14, lineHeight: 1.6 }}>
        Goals &amp; Accountability will report your district&rsquo;s performance against the goals
        you set at the start of each school year &mdash; once the Comprehensive Program Plan is part
        of your workflow. In the meantime, this report covers the data you&rsquo;d evaluate
        goals against (Sections 2&ndash;5).
      </Typography>

      <Box
        data-testid="goals-cta-card"
        sx={{
          mt: 2,
          backgroundColor: COLORS.bg,
          borderRadius: '8px',
          p: '20px',
          display: 'flex',
          flexDirection: 'column',
          gap: 1,
          alignItems: 'flex-start',
        }}
      >
        <Typography
          component="p"
          sx={{ color: COLORS.muted, fontSize: 12, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.06em' }}
        >
          Share your practice
        </Typography>
        <Typography component="h3" sx={{ color: COLORS.ink, fontSize: 16, fontWeight: 700 }}>
          How does your district set EL program goals?
        </Typography>
        <Typography sx={{ color: COLORS.muted, fontSize: 14, lineHeight: 1.6 }}>
          A 5-minute form covers who sets goals, how often, what data informs them, and what
          board-reporting framework they feed.
        </Typography>
        <Link
          href={ctaHref}
          sx={{
            mt: 1,
            display: 'inline-flex',
            alignItems: 'center',
            gap: 0.5,
            backgroundColor: COLORS.navy,
            color: '#FFFFFF',
            fontWeight: 600,
            fontSize: 14,
            borderRadius: '8px',
            px: 2,
            py: 1,
            textDecoration: 'none',
          }}
        >
          Share your practice &rarr;
        </Link>
      </Box>
    </Box>
  );
}
